import { Component, computed, inject, output } from '@angular/core';

import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { featherShoppingCart, featherMenu } from '@ng-icons/feather-icons';
import { Store } from '@ngxs/store';

import { DayjsService } from '@app/core/services/dayjs.service';
import { AvatarComponent } from '@app/core/ui/components/avatar/avatar.component';
import {
  DropdownComponent,
  DropdownItem
} from '@app/core/ui/components/dropdown/dropdown.component';
import { ToggleCartDrawerAction } from '@app/features/cart-checkout/store/cart/cart-ui.actions';
import { CartState } from '@app/features/cart-checkout/store/cart/cart.state';
import { StudentState } from '@app/features/student/store/student/student.state';
import { RemoveStudentSessionAction } from '@app/features/student/store/student-session/student-session.action';
import { StudentSessionState } from '@app/features/student/store/student-session/student-session.state';

@Component({
  standalone: true,
  selector: 'mw-store-header',
  imports: [NgIconComponent, DropdownComponent, AvatarComponent],
  providers: [
    provideIcons({
      featherShoppingCart,
      featherMenu
    })
  ],
  templateUrl: './store-header.component.html',
  styleUrl: './store-header.component.scss'
})
export class StoreHeaderComponent {
  private readonly store = inject(Store);
  private readonly dateService = inject(DayjsService);

  readonly shopLimitDate = this.store.selectSignal(StudentState.shopLimitDate);
  protected readonly shopIsAvailable = computed(() => {
    const shopLimitDate = this.shopLimitDate();

    if (!shopLimitDate) {
      return false;
    }

    const now = this.dateService.dateNow();
    const limitDate = this.dateService.convertToDate(shopLimitDate);

    const isAfter = this.dateService.compareIsAfter(limitDate, now, 'day');

    return !isAfter;
  });
  readonly profileMenu: DropdownItem[] = [
    {
      name: 'Sair',
      action: (): void => {
        this.handleLogout();
      }
    }
  ];

  readonly #student = this.store.selectSignal(StudentSessionState.student);

  protected readonly uniqueItemsCount = this.store.selectSignal(
    CartState.uniqueItemsCount()
  );

  protected readonly studentName = computed(() => {
    const student = this.#student();
    return student ? student.name : '';
  });

  readonly toggleMenuCollapse = output<void>();

  handleOpenCartDrawer() {
    this.store.dispatch(new ToggleCartDrawerAction(true));
  }

  handleLogout(): void {
    this.store.dispatch(new RemoveStudentSessionAction());
  }
}
